import moment from "moment";
import ProjectsMultiselectOption from "@/entities/ProjectsMultiselectOption";

interface Project {
  id: string,
  name: string,
  start_date: string,
  end_date: string,
}

const getProjectDropdownOptions = (projects: Project[]): ProjectsMultiselectOption[] => {
  const dateFormat = "DD MMM YYYY";

  return projects.map(project => {
    const {
      id,
      name,
      start_date: startDate,
      end_date: endDate,
    } = project;

    const formattedStartDate = moment(startDate).format(dateFormat);
    const formattedEndDate = moment(endDate).format(dateFormat);

    return {
      id,
      name,
      client_name: "", // TODO: Replace with actual client name if available
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };
  });
};

export default getProjectDropdownOptions;